import styled from 'styled-components';

export const TextButton = styled.button<{
  size?: 'tiny' | 'small' | 'medium';
  notSureButton?: boolean;
  weight?: 'light' | 'regular';
  grey?: boolean;
  underlinedText?: boolean;
}>`
  color: ${(props) =>
    props.grey
      ? props.theme.atlas.semantic.color.type.muted
      : props.theme.atlas.semantic.color.action.primary.default};
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  border: none;
  background: none;
  display: flex;
  align-items: center;
  font-size: ${(props) => {
    if (props.size === 'medium') return '15px';
    if (props.size === 'small') return '14px';
    if (props.size === 'tiny') return '11px';
  }};
  cursor: pointer;
  padding: 0;

  font-weight: ${(props) =>
    props?.weight === 'regular' ? '500' : props.notSureButton ? '400' : '100'};
  align-self: ${(props) => (props.notSureButton ? 'flex-end' : 'flex-start')};
  margin-top: ${(props) => (props.notSureButton ? '10px' : '0')};
  text-decoration: ${(props) =>
    props.notSureButton || props.underlinedText ? 'underline' : 'none'};

  &:focus {
    outline: thin;
  }

  cursor: pointer;
`;
